





























































































import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import { warningNotificationWrapper } from '../../../../logic/helpers/NotificationService'

type LabelEntry = {
  id: number
  name: string
}

@Component({
})
export default class BotLabels extends Vue {
  @VModel() labels!: { [key: number]: string }

  @Prop() createLabel!: (name: string) => Promise<{ name: string, id: number }>

  @Prop() deleteLabelFn!: (index: number) => Promise<Array<Record<number, string>>>

  @Prop() renameLabelFn!: (index: number, title: string) => Promise<Array<Record<number, string>> | void>

  currentCopy: LabelEntry | null = null

  newLabel = ''

  get tableLabels(): Array<LabelEntry> {
    return Object.entries(this.labels)
      .sort(([ aId, aKey ], [ bId, bKey ]) => Number(bId) - Number(aId))
      .map(([ id, name ], i) => {
        return {
          id: Number(id),
          name,
        }
      })
  }

  setLabelToEdit(labelId: number): void {
    this.currentCopy = {
      id: labelId,
      name: this.labels[labelId]
    }
  }

  updateLabel() {
    if (this.currentCopy) {
      this.renameLabelFn(this.currentCopy.id, this.currentCopy.name)
        .then(res => {
          if (res) {
            this.currentCopy = null
          }
        })
    }
  }

  createNewLabel(): void {
    if (this.newLabel) {
      this.createLabel(this.newLabel)
        .then(({ name, id }) => {
          this.labels[id] = name
        })
        .finally(() => this.newLabel = '')
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('fill_data_alert').toString())
    }
  }

  deleteLabelWarn(id: number): void {
    this.$confirm({
      title: this.$t('remove_label_warn_title').toString(),
      content: this.$t('remove_label_warn_text').toString(),
      onOk: () => this.deleteLabelFn(id)
    })
  }
}
